import { injectable } from '~/container'
import { langFallback$Fetch } from '../../../lang/utils/langfetch'
import { z } from 'zod'

const PriceSchema = z.object({
  amountMinor: z.number(),
  currency: z.string(),
})

export const NextBookingSchema = z.object({
  arrive: z.string(),
  balanceDueDate: z.string().nullable(),
  campsiteName: z.string(),
  campsitePrimaryPhoto: z.string().nullable(),
  depart: z.string(),
  payment: z.object({
    timing: z.string().nullable(),
    dueDate: z.string().nullable(),
    status: z.string().nullable(),
    statusDisplay: z.string().nullable(),
  }),
  prettyId: z.string(),
  price: PriceSchema,
  remainder: PriceSchema,
})

export type NextBooking = z.infer<typeof NextBookingSchema>

@injectable()
export class NextBookingsRepositoryFetch {
  async getNext(langCode: string): Promise<NextBooking | null> {
    const response = await langFallback$Fetch(
      langCode,
      '/_/user-bookings/next-booking/',
    )
    if (!response) return null
    return NextBookingSchema.parse(response)
  }
}
